import {Toast} from "primereact/toast";
import React, {useEffect, useRef, useState} from "react";
import {Dialog} from "primereact/dialog";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {getdataAsociadoDeduccionModal, guardarAsociadoDeduccion} from "../../../api/asociadoDeduccion.service";
import {UseLoader} from "../../../hooks/useLoader";
import {confirmDialog} from "primereact/confirmdialog";
import {useForm} from "react-hook-form";


export const ModalNuevoAsociadoDeduccion = ({hide, show}) => {
    const toast = useRef(null);
    const [handleLoader] = UseLoader();
    const [terceros, setTerceros] = useState([]);
    const [asociados, setAsociados] = useState([]);
    const [cuenta, setCuenta] = useState([]);
    const {register, handleSubmit, formState: {errors}} = useForm();

    const onSubmit= async payload => {
        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoader(true);
                    const response= await guardarAsociadoDeduccion(payload);
                    const data= await response;

                    handleLoader(false);
                    if (data.estado !== 200) {
                        toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide();
                }
            });
        } catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }

    useEffect(() => {
        if (show) {
            getSelect().then(r => {
                if (r.estado === 200) {
                    const data = r;
                    setAsociados(data.data);
                    setCuenta(data.dataCuenta);
                    setTerceros(data.dataTerceros);
                } else {
                    toast.current?.show({severity: 'warn', summary: 'Alerta', detail: r.mensaje, life: 3000});
                }
            });
        }
        return () => {
            setTerceros([]);
            setAsociados([]);
            setCuenta([]);
        };
    }, [show]);

    const getSelect = async () => {
        try {
            const response = await getdataAsociadoDeduccionModal();
            console.log(response);
            return await response;
        } catch (e) {
            console.log(e)
        }
    }

    return(
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Crear nueva deduccion" visible={show} style={{width: '80vw'}}
                    onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                            <h6 className="title-modal">
                                Información Asociado
                            </h6>
                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="asociado"
                                    >
                                        Asociado
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        {...register("asociado_id", {required: true })}
                                        id="asociado">
                                        <option value="">Seleccione</option>
                                        {asociados.map((itm, i) => <option key={i} value={itm.asociado_id}>{itm.nombre}</option>)}
                                    </select>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="deduccion"
                                    >
                                        Deduccion
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        {...register("cuentadeduccion_id", {required: true })}
                                        id="deduccion">
                                        <option value="">Seleccione</option>
                                        {cuenta.map((itm, i) => <option key={i} value={itm.cuentadeduccion_id}>{itm.descripcion}</option>)}
                                    </select>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="tercero"
                                    >
                                        Tercero
                                    </label>
                                    <select
                                        className="form-input-small"
                                        required
                                        {...register("tercero_id", {required: true })}
                                        id="tercero">
                                        <option value="">Seleccione</option>
                                        {terceros.map((itm, i) => <option key={i} value={itm.tercero_id}>{itm.nombre}</option>)}
                                    </select>
                                </ContainerGroupForm>
                            </div>
                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>
                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>
                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>
            </Dialog>
        </>
    )
}
